<template>
    <div class="dot-hints">
        <div class="item">
            <div class="dot">★</div>选中
            <span class="set-config" @click="setCircle">设置</span>
        </div>
        <div class="item">
            <div class="dot"></div>待调度
        </div>
        <div class="item">
            <div class="shape"></div>非待调度
        </div>
        <!-- <div class="item"><div class="dot" style="background-color: #219ddd"></div>待装车</div>-->
        <!-- <div class="item">
            <img src="../map/customer.png">客户
        </div> -->
        <div class="item">
            <img src="../map/warehouse.png">仓库
        </div>
    </div>
</template>

<script>
export default {
    name: 'vdc-dot-hints',
    data () {
        return {
        };
    },
    methods: {
        setCircle () {
            this.$emit('setCircle');
        }
    }
};
</script>

<style scoped lang="less">
.dot-hints {
    position: absolute;
    right: 16px;
    bottom: 17px;
    background-color: white;
    padding: 10px 0 10px 10px;

    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;

    .item {
        img {
            width: 15px;
            margin-right: 5px;
        }

        display: flex;
        align-items: center;

        font-size: 12px;
        line-height: 1.5;
        color: #666;

        .dot {
            display: flex;
            justify-content: center;
            align-items: center;

            .rhombus {
                background-color: yellow;
                width: 6px;
                height: 6px;
                transform: rotate(45deg);
            }

            background-color: #d81e06;
            color: yellow;
            width: 14px;
            height: 14px;
            border-radius: 10px;
            margin-right: 6px;
        }

        .shape {
            width: 12px;
            height: 12px;
            background-color: #d81e06;
            transform: rotate(45deg);
            margin-right: 10px;
        }

        .set-config {
            margin-left: 10px;
            color:#709ff9;
            border: none;
        }

        .set-config:hover {
           cursor: pointer;
        }
    }
}
</style>
